export default (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <defs>
      <linearGradient id="stackadapt-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6366F1" />
        <stop offset="100%" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
    <rect width="100" height="100" rx="20" fill="url(#stackadapt-gradient)" />
    <path
      d="M30 35 L50 35 C60 35 70 40 70 50 C70 60 60 65 50 65 L30 65 M30 65 L50 65 C60 65 70 70 70 80 C70 90 60 95 50 95 L30 95"
      fill="none"
      stroke="white"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(0, -15)"
    />
  </svg>
);
